import NumberTools from "@/utils/numberTools.js";

// 价格的千分位格式化
export default {
    filters: {
        priceToLocaleString(val) {
            return NumberTools.toLocaleString(val);
        },
    },
    methods: {
        // 适配elTableColumn
        /**
         * 使用案例
         * <el-table-column
                label="协议价(元)"
                prop="price"
                width="100"
                :formatter="elTableFomatter"
            >
            </el-table-column>
         */
        elTableFomatter(row, column, cellValue, index) {
            return NumberTools.toLocaleString(cellValue);
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/priceFormat.js